import { makeAutoObservable } from 'mobx'
import { t } from '@store/I18nStore'

export const EMAIL_NOT_VERIFIED_CODE = 'EMAIL_NOT_VERIFIED'
export const EMAIL_VERIFICATION_PROFILE_PATH = '/myProfile'

function defaultVerifyMessage(): string {
  return t('auth.confirm_email.title')
}

export class EmailVerificationStore {
  blocked = false
  message = ''
  /** Bumped when the operator confirms email so Centrifuge can connect. */
  connectionEpoch = 0

  constructor() {
    makeAutoObservable(this)
  }

  apply(payload?: { message?: string | null }): void {
    const next =
      typeof payload?.message === 'string' && payload.message.trim()
        ? payload.message.trim()
        : defaultVerifyMessage()
    const alreadyBlocked = this.blocked
    this.blocked = true
    this.message = next
    if (!alreadyBlocked) this.connectionEpoch += 1
  }

  /** Email confirmed (or user asked to retry) — allow realtime again. */
  clearAndReconnect(): void {
    const wasBlocked = this.blocked
    this.blocked = false
    this.message = ''
    if (wasBlocked) this.connectionEpoch += 1
  }

  reset(): void {
    this.blocked = false
    this.message = ''
  }
}

export const emailVerificationStore = new EmailVerificationStore()
